import http from '@/plugins/axios';

export default {
  getStatistics({ fromDate, toDate, requestsWithReviewsOnly }) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
      requestsWithReviewsOnly,
    };
    return http
      .get('/stats/main-data', {
        params,
      })
      .then(res => res.data);
  },
  getCouponAndInfluencedStats(fromDate, toDate) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/coupon-and-influenced-stats', {
        params,
      })
      .then(res => res.data);
  },
  getInfluencedOrders: ({ rowsPerPage, sortBy, descending, page }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };
    return http
      .get('/influenced-orders/datatables', {
        params,
      })
      .then(res => res.data);
  },
  getCouponInfluencedOrders: ({ rowsPerPage, sortBy, descending, page }) => {
    const params = {
      start: rowsPerPage * (page - 1) || 0,
      length: rowsPerPage,
      order: sortBy,
      orderDirection: descending ? 'desc' : 'asc',
    };
    return http
      .get('/coupon-influenced-orders/datatables', {
        params,
      })
      .then(res => res.data);
  },
  getReviewsPerPeriod(period) {
    const params = {
      period,
    };
    return http
      .get('/stats/reviews-per-period', {
        params,
      })
      .then(res => res.data);
  },
  getReviewRequestsMonthlyStats(months) {
    const params = {
      months,
    };
    return http
      .get('/stats/review-requests-monthly-stats', {
        params,
      })
      .then(res => res.data);
  },
  getDailyInfluencedOrderStats(fromDate, toDate) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/daily-influenced-order-stats', {
        params,
      })
      .then(res => res.data);
  },
  getDailyReviewStats(fromDate, toDate) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/daily-review-stats', {
        params,
      })
      .then(res => res.data);
  },
  getCouponInfluencedStats(fromDate, toDate) {
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/coupon-and-influenced-stats', {
        params,
      })
      .then(res => res.data);
  },
  getDailyReviewRequestStats(fromDate, toDate) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/daily-review-request-stats', {
        params,
      })
      .then(res => res.data);
  },
  getDailyCouponStats(fromDate, toDate) {
    // format YYYY-MM-DD
    const params = {
      fromDate,
      toDate,
    };
    return http
      .get('/stats/daily-coupon-stats', {
        params,
      })
      .then(res => res.data);
  },
};
